import React from "react"
import { Container, Row, Col } from "reactstrap"
import styled from "styled-components"
import { media } from "utils/Media"
import ContainerMax from "components/shared/ContainerMax"
import ContentMax from "components/shared/ContentMax"
import Ticket from "components/shared/Ticket"
import WPLink from "components/shared/WPLink"

const TicketsStyled = styled.div`
	padding-top: 50px;
	width: 100%;
	background: ${props => props.theme.colors.primary};
	
	&.no-title {
		background: ${props => props.theme.colors.primary};
		padding: 2rem 0;
		margin-top: 24px;
		margin-bottom: 24px;
		@media ${media.md} {
			margin-top: 50px;
		}	 
		@media ${media.xl} {
			padding: 2rem;
		}
	}

	h3 {
		font-size: 1.125rem;/*18*/
		font-family: ${props => props.theme.font.family.bold};
		color: ${props => props.theme.colors.black};
		line-height: 1.44;
		margin: 12px 0 16px;
		font-weight: 400;	
		
	    @media ${media.md} {
			font-size: 1.5rem;/*24*/
			margin: 45px 0 50px;
			line-height: 1.5;
	    }
	}

	.bottomLink {
		position: absolute;
		bottom: -3rem;
	}
`

const Tickets = (props) => {
	return (
    <ContainerMax
			className={`my-5 ${props.block.bottomLink && 'mb-5'} bkg-primary`} 
			// bg={props.block.displayBackground === "yes" ? bg : false}
		>
			<ContentMax>
				<TicketsStyled className={props.block.title ? '' : 'no-title'} maxWidth="1920">
					<Container fluid>
							{/* {props.block.title ? <h3 dangerouslySetInnerHTML={{ __html: props.block.title }} />	: null } */}
							<Row className="justify-content-center">
								{props.block.tickets && props.block.tickets.map((node, i) => (
									<Col sm={10} md={6} lg="4" key={i} className="pb-3">
										<Ticket 
											data={node} 
											key={i} 
											id={`ticket${i}`} 
											displayIncludes={props.block.displayIncludes}
										/>
									</Col>
								))}
							</Row>
						{props.block.bottomLink && 
							<WPLink url={props.block.bottomLink.url} target={props.block.bottomLink.target} button color="black" className="bottomLink">
								{props.block.bottomLink.title}
							</WPLink>
						}
					</Container>
				</TicketsStyled>
			</ContentMax>
		</ContainerMax>
	)
}

export default Tickets